import React from 'react'

import { useDispatch } from 'react-redux'

// Components

import SectionHeading from '../../../../UI/SectionHeading/SectionHeading';
import Alert from '../../../../UI/Alert/Alert';
import Button from '../../../../UI/Button/Button';
import ButtonWithIcon from '../../../../UI/ButtonWithIcon/ButtonWithIcon';
import PersonalReferenceFields from '../PersonalReferenceFields';

// Utilities

import { addItemToArray, removeItemFromArray } from '../../../../../utilities/helper-functions';

import { initialValues } from '../InitialValues';

export default function PersonalReferences({formik, formStep, setFormStep}) {
    const dispatch = useDispatch();

    return (
    <>
      <SectionHeading text={'Conozcámonos un poco más'} />

        <Alert text={'Para completar una solicitud de apertura de cuenta es obligatoria una referencia personal.'} />

        {formik.values?.personalReferences?.map((reference, index) => (
            <PersonalReferenceFields
                i={index}
                key={index}
                formik={formik}
                index={index}
            />
        ))}

        <>
            <ButtonWithIcon
                action={() => addItemToArray(formik, 'personalReferences', initialValues.personalReferences[0])}
                label={'Añadir Referencia'}
                disabled={formik.values?.personalReferences?.length === 3}
            />

            <ButtonWithIcon
                action={() => removeItemFromArray(formik, 'personalReferences')}
                icon={'delete'}
                disabled={formik.values?.personalReferences?.length === 1}
            />
        </>

        <div className='form-actions'>

            <Button
                action={() => formik.values?.hasBankReference === 'no' ? dispatch(setFormStep(formStep - 1)) : dispatch(setFormStep(formStep - 2))}
                label={'Regresa'}
                secondaryStyle={true}
            />

            <Button
                type="submit"
                action={formik.handleSubmit}
                label={'Continua'}
                // disabled={!formik.isValid}
            />

        </div>
    </>
  )
}
